<template>
  <v-row>
    <create-repository />
    <repository-table />
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreateRepository from '@/components/Services/Hosting/Shared/Git/CreateRepository'
import RepositoryTable from '@/components/Services/Hosting/Shared/Git/RepositoryTable'

export default {
  name: 'GitView',
  components: {
    CreateRepository,
    RepositoryTable
  },
  data: () => ({
    clone: false,
    rootPath: '',
    model: {
      cloneUrl: '',
      name: '',
      repository_path: '',
      type: 'git'
    },
    editModel: {
      name: '',
      branch: ''
    },
    headers: [
      {
        text: 'Repository',
        value: 'name'
      },
      {
        text: 'Repository Path',
        value: 'repository_root'
      },
      {
        text: 'Actions',
        value: 'actions'
      },
    ],
    basicInformationModal: false,
    removeModal: false,
    editModal: false,
    repositoryToShow: {},
    repositoryToDelete: {},
    createLoading: false,
    deleteLoading: false,
    editLoading: false
  }),
  computed: {
    ...mapGetters({
      repositories: 'hosting_git/repositories'
    })
  },
  mounted () {
    this.getRootPath()
    this.getRepositories({ serviceId: this.$route.params.hostingid, username: this.$route.query.user })
  },
  methods: {
    ...mapActions({
      getRepositories: 'hosting_git/getRepositories',
      getHostingSettings: 'hosting_git/getHostingSettings',
      createRepo: 'hosting_git/createRepo',
      editRepo: 'hosting_git/editRepo',
      deleteRepo: 'hosting_git/deleteRepo'
    }),
    async getRootPath () {
      try {
        const { data } = await this.getHostingSettings({
          serviceId: this.$route.params.hostingid,
          username: this.$route.query.user,
        })

        this.rootPath = `${data.home}/`
      } catch (e) {

      }
    },
    async createRepository () {
      try {
        this.createLoading = true

        const source = {
          remote_name: 'origin',
          url: this.model.cloneUrl
        }

        await this.createRepo({
          name: this.model.name,
          repository_root: `${this.rootPath}${this.model.repository_path}`,
          type: 'git',
          source_repository: this.clone ? JSON.stringify(source) : undefined,
          _username: this.$route.query.user,
        })

        await this.getRepositories(this.$route.query.user)

        this.model.cloneUrl = ''
        this.model.name = ''
        this.model.repository_path = ''
      } catch (e) {

      } finally {
        this.createLoading = false
      }
    },
    showDetails (item) {
      Object.assign(this.repositoryToShow, item)

      this.basicInformationModal = true
    },
    hideDetails () {
      this.basicInformationModal = false
      this.repositoryToShow = {}
    },
    openDeleteModal (item) {
      Object.assign(this.repositoryToDelete, item)

      this.removeModal = true
    },
    closeDeleteModal () {
      this.removeModal = false
      this.repositoryToDelete = {}
    },
    async deleteRepository () {
      try {
        this.deleteLoading = true

        await this.deleteRepo({
          repository_root: this.repositoryToDelete.repository_root,
          _username: this.$route.query.user,
        })
        await this.getRepositories(this.$route.query.user)
        this.closeDeleteModal()
      } catch (e) {
        console.log(e)
      } finally {
        this.deleteLoading = false
      }
    },
    openEditModal (item) {
      Object.assign(this.repositoryToShow, item)
      this.editModel.name = this.repositoryToShow.name
      this.editModel.branch = this.repositoryToShow.branch

      this.editModal = true
    },
    closeEditModal () {
      this.editModal = false
      this.repositoryToShow = {}
    },
    async editRepository () {
      try {
        this.editLoading = true

        await this.editRepo({
          repository_root: this.repositoryToShow.repository_root,
          name: this.editModel.name,
          branch: this.editModel.branch ?? undefined,
          _username: this.$route.query.user,
        })
        await this.getRepositories(this.$route.query.user)
        this.closeEditModal()
      } catch (e) {
        console.log(e)
      } finally {
        this.editLoading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
